module.exports = __webpack_public_path__ + "img/pix.f4a7a63c.png";